import React from 'react';

import Grid from 'material-ui/Grid';
import { Select, TextField, DateTimePicker, Validations, withValidatedInputs } from '../../../../components/forms';

import Button from 'material-ui/Button';
import {Delete} from 'material-ui-icons';

import Dialog, {
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from 'material-ui/Dialog';

import Input, {InputLabel} from 'material-ui/Input';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import Avatar from 'material-ui/Avatar';
import Switch from 'material-ui/Switch';

import moment from 'moment-timezone';

import tsl from './../../../tsl';
import { getSettings } from 'utils/client';

export class EventForm extends React.Component {
	state = {
	};

	propagateChanges = (event) => {
		this.props.onChange(event);
	};

	handleDateTimeChange = (value) => (date) => {
		let event = this.props.event;
		event[value] = moment(date).format("YYYY-MM-DD HH:mm:ss");
		//console.log(value, event[value]);
		this.propagateChanges(event);
	};

	handleChange = (e) => {
		let event = this.props.event;
		event[e.target.name] = e.target.value;
        event = JSON.parse(JSON.stringify(event));  // from some reason, console.log(event, event.calendar_id) showed different values for event.calendar_id when changed (maybe related to using references when accesing props)
		this.propagateChanges(event);
	};

	handleSwitchChange = (name) => (e, checked) => {
		const event = {
			...this.props.event,
			[name]: checked
		};

		this.propagateChanges(event);
	};

	handleSave = () => {
		if (this.props.trySubmit()) {
			this.props.onSave();
		}
	};

	handleClose = () => {
		this.props.resetFormErrors();

		this.props.onClose();
	};

	render() {
		const {
			event
		} = this.props;

		return (
			<Dialog onClose={this.handleClose} open={event != null} >
				<DialogTitle>{tsl('calendar.eventform.header')}</DialogTitle>
				<DialogContent>

			<Grid container spacing={16}>

				<Grid item xs={12} sm={12}>
                     <TextField
											 	formActions={this.props.formActions}
												required
                        fullWidth
                        disabled={event.flight}
                        label={tsl('calendar.eventform.title')}
                        name="title"
                        value={event.title || ''}
                        onChange={this.handleChange}
                    />
                </Grid>

								<Grid item xs={12}>
									{tsl('calendar.eventform.all_day')}
									<Switch
										checked={event.all_day}
										onChange={this.handleSwitchChange('all_day')}
									/>
								</Grid>

                <Grid item xs={12} sm={6}>
										{/* NOTE: the key is intentionally using the other field, so the component is recreated when the other value is changed */}
                    <DateTimePicker
											key={`time_start_` + moment(event.time_end).format('YYYY-MM-DD HH:mm:ss')}
											formActions={this.props.formActions}
											required
											validations={[
												Validations.createIsNotLaterThan({
													label: tsl('calendar.eventform.time_end'),
													value: event.time_end
												})
											]}
                    	fullWidth
                      disabled={event.flight}
                    	label={tsl('calendar.eventform.time_start')}
	                    value={event.time_start}
	                    format={"LLL"}
	                    onChange={this.handleDateTimeChange('time_start')}
	                    showTabs={false}
	                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
	                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
											ampm={getSettings('ampm', false)}
	                />
                </Grid>

                <Grid item xs={12} sm={6}>
										{/* NOTE: the key is intentionally using the other field, so the component is recreated when the other value is changed */}
                    <DateTimePicker
											key={`time_end_` + moment(event.time_start).format('YYYY-MM-DD HH:mm:ss')}
											formActions={this.props.formActions}
											required
											validations={[
												Validations.createIsNotSoonerThan({
													label: tsl('calendar.eventform.time_start'),
													value: event.time_start
												})
											]}
                    	fullWidth
                      disabled={event.flight}
                    	label={tsl('calendar.eventform.time_end')}
	                    value={event.time_end}
	                    format={"LLL"}
	                    onChange={this.handleDateTimeChange('time_end')}
	                    showTabs={false}
	                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
	                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
											ampm={getSettings('ampm', false)}
	                />
                </Grid>

                <Grid item xs={12} sm={12}>
                     <FormControl fullWidth>
                        <InputLabel htmlFor="calendar_id">{tsl('calendar.eventform.calendar')}</InputLabel>
                        <Select
														formActions={this.props.formActions}
														required
                            name="calendar_id"
                            disabled={event.flight}
                            value={event && event.calendar_id ? event.calendar_id : 0}
                            onChange={this.handleChange}
                        >
                        	<MenuItem key={0} value={0}>{'- '+tsl('calendar.eventform.select_calendar')+' -'}</MenuItem>
                            {this.props.calendars.map((calendar) => {
                                return (<MenuItem key={calendar.id} value={calendar.id}>
                                	<Avatar style={{backgroundColor: calendar.color_hex, zoom: 0.5, marginRight: 20, display: 'inline'}} />
                                	{calendar.name}
                                </MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                     <FormControl fullWidth>
                        <InputLabel htmlFor="calendar_id">{tsl('calendar.eventform.busyavailable')}</InputLabel>
                        <Select
														name="is_available"
                            disabled={event.flight}
                            value={event && event.is_available ? event.is_available : 0}
                            onChange={this.handleChange}
                        >
                            <MenuItem key={0} value={0}>{tsl('calendar.eventform.busy')}</MenuItem>
                            <MenuItem key={1} value={1}>{tsl('calendar.eventform.available')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                     <TextField
											 	formActions={this.props.formActions}
											 	multiline
                        fullWidth
                        disabled={event.flight}
                        label={tsl('calendar.eventform.description')}
                        name="description"
                        value={event.description || ''}
                        onChange={this.handleChange}
                    />
                </Grid>

    	</Grid>

				</DialogContent>
				<DialogActions>
					{!event.id ? '' :
						<Button onClick={this.props.onDelete} style={{color: 'red'}}>
							<Delete /> {tsl('calendar.eventform.delete')}
						</Button>
					}
					<Button onClick={this.handleClose}>
						{tsl('calendar.eventform.close')}
					</Button>
					<Button onClick={this.handleSave} color="primary">
						{tsl('calendar.eventform.save')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

}

export default withValidatedInputs(EventForm);


// WEBPACK FOOTER //
// ./app/used/calendar/routes/EventForm.js